/*!
 * common.js
 * (c) 2024 Klonbits, Inc.
 * All rights reserved.
 */

document.addEventListener('DOMContentLoaded', function () {
  var lazyImages = [].slice.call(document.querySelectorAll('img.lazy'));
  var active = false;

  $('a:not([href])').each(function () {
    $(this).attr('tabindex', '0');
  });

  function lazyLoad() {
    if (active === false) {
      active = true;

      setTimeout(function () {
        lazyImages.forEach(function (lazyImage) {
          if (lazyImage.getBoundingClientRect().top <= window.innerHeight && lazyImage.getBoundingClientRect().bottom >= 0 && getComputedStyle(lazyImage).display !== 'none') {
            if (lazyImage.dataset.src != undefined && lazyImage.dataset.src != '') {
              lazyImage.src = lazyImage.dataset.src;
              lazyImage.classList.remove('lazy');
            } else {
              lazyImage.classList.remove('lazy');
            }

            lazyImages = lazyImages.filter(function (image) {
              return image !== lazyImage;
            });

            if (lazyImages.length === 0) {
              document.removeEventListener('scroll', lazyLoad);
              window.removeEventListener('resize', lazyLoad);
              window.removeEventListener('orientationchange', lazyLoad);
            }
          }
        });

        active = false;
      }, 250);
    }
  }

  lazyLoad();

  document.addEventListener('scroll', lazyLoad);
  window.addEventListener('resize', lazyLoad);
  window.addEventListener('orientationchange', lazyLoad);

  $('[data-toggle="popover"]').popover();

  $('[data-mask="credit-card"]').each(function () {
    $(this).on('input', function () {
      var $this = $(this)[0];
      var cardNumber = $this.value;

      var formattedCardNumber = cardNumber.replace(/[^\d]/g, '');
      formattedCardNumber = formattedCardNumber.substring(0, 16);

      var cardNumberSections = formattedCardNumber.match(/\d{1,4}/g);
      if (cardNumberSections !== null) {
        formattedCardNumber = cardNumberSections.join(' ');
      }

      if (cardNumber !== formattedCardNumber) {
        $this.value = formattedCardNumber;
      }
    });
  });

  $('body').on('click', function (e) {
    var target = $(e.target);

    //Popover hide

    if (target.parent().data('toggle') !== 'popover' && target.parent('.popover.show').length === 0) {
      $('[data-toggle="popover"]').popover('hide');
    }

    //Header Menu Close Trigger

    if (target.closest('.btn--hamburger').length == 0) {
      if ($('.header-nav').hasClass('is-shown')) {
        $('.header-nav').removeClass('is-shown');
        TweenMax.to(document.querySelector('.header-nav-side'), 0.25, {
          x: '-100%',
        });
      }
    }
  });

  $('[data-dismiss]').each(function () {
    $(this).on('click', function () {
      var dismissEl = $(this).data('dismiss');

      switch (dismissEl) {
        case 'search-wrapper':
          $('.' + dismissEl).removeClass('is-shown');
          $('html,body').removeClass('overflow-hidden');
          break;
        case 'search-box':
          $('.' + dismissEl).removeClass('expanded');
          break;
      }
    });
  });

  //#region .js-btn--WhatsApp
  setTimeout(function() { $(".js-btn--WhatsApp").show(); }, 20000);
  //#endregion .js-btn--WhatsApp
});

$(window).on('load', function () {
  $('body').removeClass('is-loading');

  $(document).on('click', '.js-btnCallYouTrigger', function () {
    $('#callYouModal').modal('show');
  });

  $('.btn--hamburger').on('click', function (n) {
    n.preventDefault();
    var isShown = $('.header-nav').hasClass('is-shown');

    $('.header-nav').toggleClass('is-shown');

    if (!isShown) {
      TweenMax.to(document.querySelector('.header-nav-side'), 0.5, {
        x: '0%',
      });
    } else {
      TweenMax.to(document.querySelector('.header-nav-side'), 0.25, {
        x: '-100%',
      });
    }
  });

  $('[data-toggle="dropdown-modified"]').on('click', function () {
    $(this).siblings('.dropdown-menu').toggleClass('show');
  });

  $('[data-toggle="dropdown-modified"]').on('click', function () {
    $(this).siblings('.dropdown-menu').toggleClass('show');
  });

  $('.minus-plus').each(function () {
    $(this)
      .find('.minus-plus__block > .btn')
      .on('click', function (e) {
        e.preventDefault();

        var isPlusBtn = $(this).attr('class').includes('--plus');

        var isChildBlock = $(this).closest('.minus-plus').hasClass('child-block');

        var maxLenght = isPlusBtn ? (isChildBlock ? 3 : 5) : isChildBlock ? 0 : 1;
        var incrementValue = isPlusBtn ? 1 : -1;

        var $currentCount = $(this).siblings('.count');
        var currentCount = parseInt($currentCount.text());

        if (!isNaN(currentCount) && (isPlusBtn ? currentCount < maxLenght : currentCount > maxLenght)) {
          $currentCount.text(currentCount + incrementValue);
        }
      });
  });

  $('.minus-plus.child-block .btn').on('click', function () {
    var ww = $(window).width();
    let val = parseInt($(this).parent().find('.count').text());

    const numbers = ['', '1', '2', '3'];

    for (idx in numbers) {
      let el = $(`.child-row.child-row-${numbers[idx]}`);
      if (idx <= val && idx > 0) {
        el.removeClass('d-none');

        if (ww < 768) {
          $('.search-wrapper').animate({
            scrollTop: el.offset().top,
          },
            2000,
          );
        }
      } else el.addClass('d-none');
    }
  });

  $('.dropdown.adult-box').on({
    'shown.bs.dropdown': function () {
      this.closable = false;
    },
    'hide.bs.dropdown': function () {
      return this.closable;
    },
  });

  $('.adult-box .dropdown-menu')
    .find('.submit--adult-box')
    .on('click', function () {
      var errorArray = [];

      if (errorArray.length == 0) {
        $('.adult-box.dropdown')[0].closable = true;
      }
    });

  $('.dropdown-toggle').each(function () {
    var $this = $(this);

    $(this)
      .siblings('.dropdown-menu')
      .find('a.dropdown-item')
      .on('click', function (e) {
        $(this).siblings('.dropdown-menu').find('a').removeClass('selected');

        e.preventDefault();
        $this.text($(this).text());
        $(this).addClass('selected');
      });
  });
});

$('.modal').on({
  'show.bs.modal': function () {
    $('html,body').addClass('overflow-hidden');
  },
  'hidden.bs.modal': function () {
    $('html,body').removeClass('overflow-hidden');
  },
});

$("[data-prop='tabs']").each(function () {
  $(this).tabs();
});

$('#flightModal').each(function () {
  $(this).find('.btn--default-blue').removeAttr('href');

  $(this)
    .find('.btn--default-blue')
    .on('click', function () {
      $('#chkFlightSelect').prop('checked', false);
      $('#searchForm').validate();
      $('#searchForm').submit();
    });
});

$('#btnReservationTrigger').on('click', function () {
  var ww = $(window).outerWidth();

  $('.search-wrapper').toggleClass('is-shown');
  ww < 768 ? $('html,body').addClass('overflow-hidden') : '';

  var isShown = $('.search-wrapper').hasClass('is-shown');

  TweenMax.to(document.querySelector('.search-wrapper'), 0.5, {
    translateY: isShown ? '0%' : '-15%',
  });
});

$('.main--search').each(function () {
  $('.header').addClass('search-header');
});
$('#inpSelectAirportSource').on('change', function () {
  var val = $(this).val();
  $('#inpHiddenFlightSource').val(val);
});
(function () {
  function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
  var lang = document.documentElement.lang;
  // if(!getCookie('hasTravelDocumentShow') && lang =="tr"){
  //     $('#travelPermitDocumentModal').modal('show');
  //     setCookie('hasTravelDocumentShow',1);
  // }
})();

function setCookie(name, value, days) {
  var expires = '';
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toUTCString();
  }
  document.cookie = name + '=' + (value || '') + expires + '; path=/';
}
function selectDefaultPhone(e, t) {
  switch ((e = e.toLowerCase())) {
    case 'tr':
      $(t).val('+90');
      break;
    case 'en':
      $(t).val('+44');
      break;
    case 'de':
      $(t).val('+49');
      break;
    case 'ru':
      $(t).val('+7');
  }
}
function blurHandler(s) { s.blur(); }
async function fillCountryCodes(elem, lang) {
  var $elem = $(elem),
    currentLang = lang;
  if (document.querySelectorAll(elem)[0]) {
    var optionsHTML = '';
    var countries = await fetch('/public/ContryCodesLong').then(x => x.json());
    countries.forEach(e => {
      optionsHTML += ` <option value="${e.code}" data-country="${e.name}">${e.name_Code}</option>`;
    });

    document.querySelectorAll(elem)[0].innerHTML = optionsHTML;

    [].forEach.call(document.querySelectorAll(elem), function (s) {
      s.addEventListener('focus', focus);
      s.addEventListener('blur', blur);
      blurHandler(s);
    });
    selectDefaultPhone(currentLang, elem);
  }
}

// #region NAVIGATION
function GetLetCallUsYouForm() {
  $('#letUsCallYouDiv').html('');
  var postUrl = '/tr/book-getletcallusyouform';
  $.ajax({
    url: postUrl,
    type: 'POST',
    success: async function (result) {
      $('#letUsCallYouDiv').html(result);
      fillCountryCodes();
      $('#letUsCallYouModal').modal('show');
    },
  });
}
// #endregion NAVIGATION

window.addEventListener('DOMContentLoaded', async function () {
  await fillCountryCodes('#ddlCountrySelect', $('html').attr('lang'));
  await fillCountryCodes('#ddlCountrySelectContact', $('html').attr('lang'));
});

/* #region Sending Effect */
/* Sending Effect @author: fsws
 * Usage 1: useSendingEffect({ callback: postForm, btnId: '#tryBtn', sendingText: 'Form Sending...', delay: 2000, alertText: 'Please wait...' })
 * Usage 2: useSendingEffect({ btnId: '#tryBtn', delay: 2000, callback: function() { ... } })
 * Option defaults:
 * sendingText: 'Sending...' // temporarily disabled
 * delay: 1500
 * alertText: 'Still sending, please wait...' // temporarily disabled
 */
var isSending = null;

function useSendingEffect({
  callback,
  btnId,
  sendingText,
  delay,
  alertText
}) {
  var svgLoadingIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 30" fill="#fff" style="width: 30px;height: 100%;margin-right: 10px;margin-bottom: 2px;fill: wheat;mix-blend-mode: difference;"><circle cx="15" cy="15" r="15"><animate attributeName="r" from="15" to="15" begin="0s" dur="0.8s" values="15;9;15" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="fill-opacity" from="1" to="1" begin="0s" dur="0.8s" values="1;.5;1" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="60" cy="15" r="9" fill-opacity="0.3"><animate attributeName="r" from="9" to="9" begin="0s" dur="0.8s" values="9;15;9" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="fill-opacity" from="0.5" to="0.5" begin="0s" dur="0.8s" values=".5;1;.5" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="105" cy="15" r="15"><animate attributeName="r" from="15" to="15" begin="0s" dur="0.8s" values="15;9;15" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="fill-opacity" from="1" to="1" begin="0s" dur="0.8s" values="1;.5;1" calcMode="linear" repeatCount="indefinite"></animate></circle></svg>`;
  if (isSending == null) {
    callback();
    var btn = document.querySelector(btnId);
    btnText = btn.innerHTML;
    btnOpacity = btn.style.opacity;

    btn.innerHTML = /* svgLoadingIcon + " " + sendingText || */ svgLoadingIcon + " " + btnText;
    btn.style.opacity = 0.5;
    isSending = setTimeout(() => {
      btn.innerHTML = btnText;
      btn.style.opacity = btnOpacity;
      isSending = null;
    }, delay || 1500);
  } else { /* alert(alertText || "Still sending, please wait..."); */ }
}
/* #endregion Sending Effect */

/* #region Loading Effect / Block UI Common Function */
/* Loading Effect @author: fsws
 * Usage 1: useLoadingEffect() // default loading template
 * Usage 2: useLoadingEffect({ id: 'templateElementId' })
 */
function useLoadingEffect(params) {
  let historyTraversal = (typeof window.performance != "undefined" && window.performance.navigation.type === 2);
  if (historyTraversal) return;
  params = {
    id: '',
    ...params
  };

  if (params.id !== '') {
    $.blockUI({
      message: $('#' + params.id)
    });
  } else {
    $.blockUI({
      message: `
        <div class="preloader__wrapper">
          <div class="preloader__box">
            <div class="preloader">
              <div class="preloader__stroke-svg-wrapper">
                <svg class="preloader__stroke-svg" xmlns="http://www.w3.org/2000/svg">
                  <rect class="preloader__stroke-rect preloader__stroke-rect--animate"></rect>
                </svg>
              </div>
            </div>
            <div class="preloader__logo-wrapper">
              <?xml version="1.0" encoding="UTF-8"?>
              <svg class="preloader__logo-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 198.43 58.39">
                <defs><style>.cls-1 { fill: #f5e8dd; stroke-width: 0px; }</style></defs>
                <g class="preloader__logo-svg-g"><path class="cls-1" d="m36.2,16.32h-4.68v13.72h-2.39v-13.72h-4.71v-2.14h11.77v2.14Z"/><path class="cls-1" d="m54.3,14.18v15.87h-2.43v-6.81h-7.22v6.81h-2.41v-15.87h2.41v6.89h7.22v-6.89h2.43Z"/><path class="cls-1" d="m71.87,27.9v2.14h-9.74v-15.87h9.52v2.14h-7.11v4.86h6.22v2.1h-6.22v4.62h7.33Z"/>    <path class="cls-1" d="m100.26,14.18v15.87h-2.23l-6.87-11.47v11.47h-2.41v-15.87h2.28l6.83,11.47v-11.47h2.41Z"/><path class="cls-1" d="m149.33,28.32v1.82l-.88.02c-1.4,0-2.12-.09-3.17-1.58l-2.98-4.44-1.95.04v5.87h-2.41v-15.87h6.19c3.41,0,4.84,2.47,4.84,5.01,0,2.36-1.16,4.73-4.16,4.88l2.25,3.28c.68.94,1.09.96,1.73.96h.53Zm-8.97-6.26h3.63c1.9,0,2.58-1.44,2.58-2.89s-.68-2.85-2.54-2.85h-3.68v5.73Z"/><path class="cls-1" d="m171.52,30.05l-1.16-11.07-4.68,11.07h-1.97l-4.73-11.1-1.18,11.1h-2.43l1.75-15.87h2.1l5.47,13.07,5.43-13.07h2.1l1.77,15.87h-2.47Z"/><path class="cls-1" d="m131.88,22.1c-.76-10.1-9.1-12.73-12.07-12.84-9.39-.33-13.7,6.1-13.48,12.87.32,9.65,6.48,14.24,12.79,13.79,7.02-.51,13.31-6.6,12.77-13.82Zm-9.42,10.49c-5.6,1.26-13.71-.38-13.66-6.95.05-6.51,4.39-12.99,8.63-14.64,7.21-2.8,12.72,4.87,12.72,11.16s-3.32,9.45-7.69,10.43Z"/></g>
                <g class="preloader__logo-svg-g"><path class="cls-1" d="m79.3,49.03v-2.51h-2.48v2.51h-1.28v-6h1.28v2.42h2.48v-2.42h1.28v6h-1.28Z"/><path class="cls-1" d="m87.3,42.91c1.81,0,3.14,1.38,3.14,3.12s-1.32,3.12-3.14,3.12-3.14-1.37-3.14-3.12,1.33-3.12,3.14-3.12Zm0,5.06c1.08,0,1.85-.87,1.85-1.94s-.77-1.94-1.85-1.94-1.85.88-1.85,1.94.77,1.94,1.85,1.94Z"/><path class="cls-1" d="m96.63,44.1v4.93h-1.28v-4.93h-1.68v-1.07h4.64v1.07h-1.68Z"/><path class="cls-1" d="m102.56,49.03v-6h3.86v1.07h-2.58v1.37h2.18v1.03h-2.18v1.45h2.7v1.08h-3.98Z"/><path class="cls-1" d="m111.17,49.03v-6h1.28v4.92h2.31v1.08h-3.59Z"/><path class="cls-1" d="m118.86,48.8v-1.23c.42.22.97.4,1.51.43.19,0,.37,0,.53-.03.46-.07.72-.24.72-.53,0-.4-.36-.61-1.18-.91-1.05-.38-1.67-.83-1.67-1.87s.88-1.75,2.18-1.75c.6,0,1.19.13,1.57.3v1.18c-.35-.21-.92-.37-1.47-.37-.62,0-1.02.24-1.02.63,0,.35.32.59,1.14.9,1.05.41,1.7.85,1.7,1.86,0,1.08-.82,1.73-2.23,1.73-.68,0-1.35-.15-1.78-.34Z"/></g>
              </svg>
            </div>
          </div>
        </div>
      `
    });
  }
}
/* #endregion Loading Effect / Block UI Common Function */